import { PmErrorState } from "../../components/utils/PmErrorState";

export const DashboardPageNotFound = () => {
  return (
    <PmErrorState
      variant="not_found"
      layout="page"
      dashboardTo="/dashboard"
    />
  );
};
